// +----------------------------------------------------------------------
// | 轻提示（全局单例，页面里直接 toast('提示语')）
// +----------------------------------------------------------------------
import { useEffect, useState } from 'react';
import './Toast.less';

let pushToast = null;

/**
 * @param {string} msg
 * @param {'info'|'success'|'error'} type
 */
export function toast(msg, type = 'info') {
  if (pushToast) pushToast({ msg, type, id: Date.now() });
}

export function ToastHost() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    pushToast = (item) => {
      setItems((prev) => [...prev, item]);
      setTimeout(() => {
        setItems((prev) => prev.filter((it) => it.id !== item.id));
      }, 2600);
    };
    return () => {
      pushToast = null;
    };
  }, []);

  if (!items.length) return null;

  return (
    <div className="toast-host">
      {items.map((item) => (
        <div key={item.id} className={`toast toast-${item.type}`}>
          {item.msg}
        </div>
      ))}
    </div>
  );
}
